<div class = "datePickerNav">
<div id="report-section" class="col-md-12 ng-bento">
	<h1 class="no-top-margin" data-qe-id="header-title" translate="Bluemoon.Shell.Navigation.FirmManagementReports">
	</h1>
	<div class="py-3 mb-3 bg-light">
		<ul id="reportLink" class="list-inline pl-4">
			<li><a (click)="openAddEditProfilePopup(profileTemplate,'add')"> <i class="bento-icon-add"></i><span translate="onvio.reporting.FirmManagementReportProfile.header.AddProfile"></span></a>
			</li>
			<li><a (click)="isEditAllowed && openAddEditProfilePopup(profileTemplate,'edit')"
					[class.disabled]="!isEditAllowed"> <i class="bento-icon-edit"></i><span translate="onvio.reporting.FirmManagementReportProfile.header.EditProfile"></span></a></li>
			<li><a (click)="isRemoveAllowed && openRemovePopup()" [class.disabled]="!isRemoveAllowed">
					<i class="bento-icon-remove"></i><span translate="onvio.reporting.FirmManagementReportProfile.header.removeProfile"></span></a></li>
		</ul>
	</div>
	<div class="card">
		<div class="card-body report-item">
			<bento-splitter-group [(leftOpened)]="isLeftOpened" [(leftWidth)]="leftWidth">
				<bento-splitter-group-left>
					<!-- Report Tree -->
					<app-firm-management-report-tree (readStandardIds)="readStandardIds($event)"
						(readFirmIds)="readFirmIds($event)" (readStaffIds)="readStaffIds($event)"
						(selectedProfile)="selectedProfile($event)"></app-firm-management-report-tree>
				</bento-splitter-group-left>

				<bento-splitter-group-main [bentoBusyLoader]="isLoaderBusy" [size]="'md'">

					<ng-container *ngIf="displayRightPaneContent === 'profileOption'">
						<app-firm-management-report-option (success)="profileSuccess($event)" [selectedProfile]="selectedProfileInfo">
						</app-firm-management-report-option>
					</ng-container>

					<ng-container *ngIf="displayRightPaneContent === 'defaultText'">
						<div class="p-2">
							<p><span translate="onvio.reporting.FirmManagementReportProfile.rightPane.defaultText"></span></p>
						</div>
					</ng-container>

				</bento-splitter-group-main>
			</bento-splitter-group>
		</div>
	</div>
</div>
</div>
<!-- Modal Popup for add profile. -->

<ng-template #profileTemplate>
	<app-firm-management-report-profile [profileId]="sendProfileId" (success)="profileSuccess($event)" (close)="closePopup()">
	</app-firm-management-report-profile>
</ng-template>

<ng-template #ProgressPopup>

	<div class="modal-header">
		<span translate="onvio.reporting.FirmManagementReportProfile.deletionProgressPopup.message"></span>
	</div>
	<div class="modal-body ">
		<p>Processing {{currentItem}} of {{profileIds.length}}</p>
		<p>
			<ngb-progressbar [type]="progressBarType" [value]="progressValue"></ngb-progressbar>
		</p>
	</div>
</ng-template>

<ng-template #StatusPopup>

	<div class="modal-header">
		<span translate="onvio.reporting.FirmManagementReportProfile.statusPopup.message"></span>
	</div>
	<div class="modal-body">
		<li *ngFor="let error of errors">{{error}}</li>
	</div>
	<div class="modal-footer ">
		<button class="btn btn-primary" (click)="closePopup();"><span translate="onvio.reporting.FirmManagementReportProfile.statusPopup.close"></span></button>
	</div>
</ng-template>
